import React from "react";
import { Form, Input, Button, Checkbox, message } from "antd";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "../firebase/firebase";

const LoginPage = ({ setIsLogin }) => {
  const navigate = useNavigate();

  const onFinish = (values) => {
    console.log("Success:", values);
    return;
    setIsLogin(true);
    navigate("/admin");
    message.success("Login successful!");
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Login failed. Please check your inputs.");
  };

  const onFinishLogin = async (values) => {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        values.email,
        values.password
      );
      console.log("userCredential", userCredential);
      navigate("/admin");
      message.success("Login successful!");
      return userCredential.user;
    } catch (error) {
      console.error("Login Error:", error.message);
      throw error;
    }
  };

  const goToLandingPage = () => {
    navigate("/");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f0f2f5",
      }}
    >
      <div
        style={{
          padding: "24px",
          background: "#fff",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "24px" }}>Login</h2>
        <Form
          name="loginForm"
          initialValues={{ email: "sitthichai.bas1204@gmail.com" }}
          onFinish={onFinishLogin}
          onFinishFailed={onFinishFailed}
          layout="vertical"
        >
          <Form.Item
            label="Email"
            name="email"
            rules={
              [
                //   { required: true, message: "Please enter your email!" },
                //   { type: "email", message: "Please enter a valid email!" },
              ]
            }
          >
            <Input placeholder="Enter your email" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            // rules={[{ required: true, message: "Please enter your password!" }]}
          >
            <Input.Password placeholder="Enter your password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Login
            </Button>
          </Form.Item>

          <Form.Item>
            <Button
              onClick={() => goToLandingPage()}
              type="primary"
              htmlType="landing"
              block
            >
              Go to Landing Page
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LoginPage;
